// Every icon in the app is decorative — where one is a control's only
// content, the control carries its own aria-label.
function Icon({ icon, iconType = "fa-regular", className = "" }) {
	return (
		<i
			aria-hidden="true"
			className={`${iconType} ${icon}${className ? ` ${className}` : ""}`}
		></i>
	);
}

export default Icon;
